import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import InfoTooltip from '@/metrics/components/InfoTooltip/InfoTooltip'

import * as Styles from './styles'

const EarningsTile = ({ label, tooltip, value }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      <Styles.Header>
        <Text type="allCapsM" color={theme.colors.text.muted}>
          {label}
        </Text>
        <InfoTooltip text={tooltip} />
      </Styles.Header>
      <Text type="titleL">{value}</Text>
    </Styles.Container>
  )
}

export default EarningsTile
